export const id = {
    navbar: {
        choose_language: 'Pilih Bahasa Anda!!',
        lang: 'Bahasa',
        list: 'Daftar Menu',
        home: 'Beranda',
        product: 'Produk',
        products: 'Daftar Produk',
        request: 'Request Pesanan',
        category: 'Kategori',
        series: 'Seri',
        character: 'Karakter',
        search: 'Cari Product..',
        keyword: 'Masukkan Kata Kunci...',
        cart: 'Belanja',
        login: 'Masuk',
        register: 'Daftar',
        dropdown: {
            request: 'Pesanan Custom',
            list_order: 'Daftar Pesanan',
            wishlist: 'Favorit',
            profile: 'Profil',
            address: 'Alamat',
            logout: 'Keluar',
            cart: 'Keranjang',
            cart_detail: 'Lihat Detail'
        },
        message: 'Kirim Pesan',
        empty: {
            title: 'Keranjang Kosong',
            desc: 'Waktunya untuk menambahkan lebih banyak Produk!'
        },
        stores: {
            tokopedia: 'Tokopedia',
            booth: 'Booth',
            offline_store: 'Toko Offline'
        }
    },
    login: {
        title: 'Masuk',
        email: 'Email',
        password: 'Kata Sandi',
        cta: 'Masuk',
        remember: 'Ingat Saya',
        forgot: 'Lupa Kata Sandi?',
        or: 'Atau Masuk Dengan',
        register: 'Belum Punya Akun?',
        register_desc:
            'Daftar Sekarang dan Dapatkan Akses ke Produk Eksklusif Kami!!',
        register_cta: 'Daftar Sekarang',
        account: 'Akun'
    },
    register: {
        title: 'Daftar',
        first: 'Nama Depan',
        last: 'Nama Belakang',
        email: 'Email',
        phone: 'Nomor Telepon',
        password: 'Kata Sandi',
        confirm: 'Konfirmasi Kata Sandi',
        cta: 'Daftar',
        login: 'Sudah Punya Akun?',
        login_desc: 'Masuk untuk Melanjutkan Belanja',
        login_cta: 'Masuk Disini'
    },
    product: {
        title: 'Semua Produk',
        price: 'Harga',
        filter: {
            newest: 'Terbaru',
            most_buy: 'Paling Banyak Dibeli',
            popular: 'Populer',
            discount: 'Diskon',
            pre_order: 'Pre-Order',
            ready_stock: 'Ready Stock',
            lowest_price: 'Harga Terendah',
            highest_price: 'Harga Tertinggi'
        },
        cta: 'Lihat Lebih Banyak',
        empty: {
            title: 'Produk Tidak Tersedia',
            desc: 'Maaf, produk yang Anda cari tidak tersedia saat ini'
        }
    },
    shorts: {
        title: 'Tonton Video Pendek Kami',
        cta: 'Lihat Semua Video'
    },
    search: {
        filter: {
            title: 'Filter Produk',
            close: 'Tutup',
            min: 'Min Harga',
            max: 'Max Harga',
            category: 'Kategori',
            series: 'Seri',
            character: 'Karakter',
            condition: 'Kondisi',
            other: 'Lainnya',
            stock: 'Ready Stock',
            order: 'Pre-Order',
            apply: 'Terapkan Filter',
            clear: 'Hapus Filter'
        },
        sort: {
            title: 'Urutkan',
            relevant: 'Relevan',
            newest: 'Terbaru',
            price_high: 'Harga Tertinggi',
            price_low: 'Harga Terendah'
        }
    },
    section: {
        custom: {
            heading: 'Menerima Pesanan',
            title: 'Custom Seluruh Dunia',
            description:
                'Kami Menerima Pesanan Import dari Seluruh Dunia, dengan Jepang sebagai Negara Utama. Hubungi Kami untuk Info Lebih Lanjut!!',
            button: 'Info Lebih lanjut'
        },
        categories: {
            title: 'Kategori'
        },
        news: {
            title: 'Berita & Event'
        },
        view: 'Lihat Semua',
        read: 'Selengkapnya'
    },
    request: {
        title: 'Pesanan Custom',
        search: 'Cari Pesanan',
        product_url: 'Silakan berikan link ke item yang Anda inginkan!',
        brief: 'Hmm, barang apa itu?',
        brief_placeholder:
            'Silakan lengkapi data dibawah ini sehingga Xiaoken dapat memahami item yang Anda inginkan.',
        name: 'Nama Produk',
        name_placeholder: 'Input Nama Produk',
        price: 'Harga',
        quantity: 'Jumlah',
        quantity_placeholder: 'Total Jumlah',
        shipping: 'Kemana Kamu Ingin Mengirimkannya?',
        notice: 'Perhatian',
        notice_desc:
            'Kami akan memberitahukan detail pesanan custom Kamu melalui whatsapp seperti pengiriman, tarif dan total pembayaran. Pastikan nomor telepon kamu benar.',
        cta: 'Kirim Pesanan',
        slider_title: 'Belanja dari mana saja semudah menyalin link!',
        slider_desc:
            'Kamu bisa berbelanja item dari berbagai marketplace seperti Amazon, Rakuten, dan lainnya. Cukup salin link item yang kamu inginkan dan tempelkan pada kolom di atas.',
        history: 'Riwayat Pesanan',
        guide: 'Panduan',
        status: {
            all: 'Semua',
            approved: 'Disetujui',
            pending: 'Menunggu',
            canceled: 'Dibatalkan'
        },
        reset: 'Hapus Filter',
        history_number: 'Nomor Pesanan',
        history_link: 'Link Produk',
        history_chat: 'Chat Penjual',
        history_empty: 'Riwayat Kosong',
        history_empty_desc:
            'Belum Ada Pesanan Custom, Yuk Tambahkan Pesanan!!'
    },
    product_page: {
        product: 'Produk',
        detail: {
            title: 'Detail Produk',
            category: 'Kategori',
            sku: 'SKU',
            min_order: 'Min Pesanan',
            condition: 'Kondisi',
            condition_new: 'Baru',
            condition_used: 'Bekas',
            status: {
                duration: 'Durasi',
                days: 'Hari'
            },
            character: 'Karakter',
            stock: 'Stok',
            stock_out: 'Stok Habis',
            size: 'Ukuran (P.L.T)',
            weight: 'Berat',
            tags: 'Tags'
        },
        select: 'Pilih',
        quantity: 'Jumlah',
        order_notes: 'Catatan Pesanan',
        notes_placeholder: 'Tulis catatan pesanan kamu disini...',
        add_cart: 'Keranjang',
        wishlist: 'Favorit',
        checkout_now: 'Bayar Sekarang',
        desc: 'Deskripsi Produk',
        share: 'Bagikan',
        similar: 'Produk Serupa',
        recent: 'Produk Terakhir Dilihat',
        interest: 'Kamu Mungkin Tertarik',
        free_shipping: {
            title: 'Gratis Ongkir Tersedia',
            desc: 'Dapatkan GRATIS ongkir untuk pesanan di atas',
            amount: 'Rp 9.000.000'
        }
    },
    checkout: {
        title: 'Checkout Pesanan',
        add: 'Tambah Produk',
        shipment: 'Pengiriman',
        payment: 'Pembayaran',
        status: 'Status',
        cart: {
            title: 'Keranjang Belanja',
            selected: 'Dipilih',
            empty: 'Keranjang Kamu Kosong',
            empty_desc: 'Waktunya untuk menambahkan lebih banyak Produk!',
            cta: 'Lanjut ke Pengiriman'
        },
        table: {
            product: 'Produk',
            variant: 'Variant',
            weight: 'Berat',
            quantity: 'Jumlah',
            action: 'Aksi',
            shopping_total: 'Total Belanja',
            total_weight: 'Total Berat',
            alert: 'Hapus Produk untuk Melanjutkan',
            notes: 'Catatan',
            stock_out: 'Stok Habis',
            back: 'Lanjut Belanja'
        }
    },
    summary: {
        title: 'Ringkasan Pesanan',
        coupon: 'Kode Kupon',
        shop_total: 'Total Belanja',
        ship_cost: 'Biaya Pengiriman',
        insurance: 'Biaya Asuransi',
        discount: 'Diskon',
        pack: 'Biaya Packing',
        gov_tax: 'Pajak Pemerintah',
        payment_fee: 'Biaya Pembayaran',
        grand: 'Total Bayar',
        apply_coupon: 'Gunakan Kupon', // or 'Terapkan Kupon'
        coupon_applied: 'Kupon Digunakan',
        items: 'Items',
        free_shipping: 'Gratis Ongkir',
        select_expedition: 'Pilih ekspedisi',
        tooltip: {
            free_shipping: 'Dapatkan <b>Gratis Ongkir</b> jika total belanja anda di atas ',
            insurance_fee: 'Produk dengan asuransi akan dikenakan biaya sebesar',
            minimum: 'Minimum',
            tax_fee: 'Produk tanpa pajak akan dikenakan biaya sebesar',
            paypal_fee: 'Kami menambahkan biaya tambahan untuk menyesuaikan dengan <b class="capitalize">{method}</b>. Biayanya adalah',
            final_payment: 'berdasarkan Pembayaran Akhir'
        }
    },
    shipment: {
        title: 'Pengiriman',
        address: 'Alamat Penerima',
        page: 'Alamatku',
        empty: 'Alamat Kamu Kosong',
        empty_desc:
            'Silakan tambahkan minimal satu alamat untuk menyelesaikan pesanan',
        card: {
            type: 'Tipe Alamat',
            primary: 'Utama',
            selected: 'Dipilih',
            receipt: 'Penerima',
            country: 'Negara',
            province: 'Provinsi',
            city: 'Kota',
            address: 'Alamat',
            detail: 'Detail Alamat',
            postal: 'Kode Pos',
            cta: 'Pilih Alamat Lain'
        },
        form: {
            list: 'List Alamat',
            add: 'Tambah Alamat Baru',
            update: 'Update Alamat',
            type: 'Tipe Alamat',
            receipt: 'Nama Penerima',
            email: 'Email Penerima',
            phone: 'Nomor Telepon',
            country: 'Negara',
            province: 'Provinsi',
            city: 'Kota',
            postal: 'Kode Pos',
            address: 'Alamat',
            detail: 'Nomor Bangunan / Lantai / Unit',
            main: 'Atur sebagai Alamat Utama',
            yes: 'Ya',
            no: 'Tidak',
            cta: 'Tambah Alamat',
            cta2: 'Update Alamat',
            notice_email:
                'Informasi apapun mengenai pengiriman dan pengantaran akan dikirimkan ke email ini',
            notice_phone:
                'Input menggunakan format internasional, contoh 628123456789'
        },
        expedition: {
            title: 'Pilih Ekspedisi',
            sent: 'Dikirim Dari',
            destination: 'Tujuan ke',
            estimate: 'Estimasi',
            days: 'Hari'
        },
        method: 'Metode Pembayaran',
        notes: 'Catatan Pengiriman',
        notes_placeholder: 'Tulis catatan pengiriman kamu disini...',
        cta: 'Bayar Sekarang',
        insurance: {
            title: 'Asuransi Pengiriman',
            active: 'Aktifkan Asuransi',
            fee: 'Biaya Asuransi',
            desc: 'Salah satu produk yang kamu beli membutuhkan asuransi, untuk pengiriman yang lebih aman sebesar',
            yes: 'Ya',
            no: 'Tidak'
        }
    },
    payment: {
        guide: 'Panduan Pembayaran',
        title: 'Pembayaran',
        close: 'Ditutup dalam',
        invoice: 'Cek Invoice',
        days: 'Hari',
        hour: 'j',
        minute: 'm',
        second: 'd',
        expirate: 'Pembayaran Kadaluarsa',
        notice: 'Terima kasih telah melakukan pemesanan. Kami mengingatkan Anda untuk menyelesaikan pembayaran pesanan Anda sebelum batas waktu yang akan datang. Jangan lupa untuk mengunggah Bukti Pembayaran pada kolom di bawah.',
        upload: 'Unggah Bukti Pembayaran',
        uploaded: 'Bukti Pembayaran Kamu',
        total: 'Total Pembayaran'
    },
    status: {
        expirate: 'Waktu Pembayaran Kamu Habis',
        expirate_desc:
            'Waktu pembayaran kamu telah habis, silakan melakukan pemesanan baru',
        expirate_cta: 'Pesan Baru',
        reject: 'Pembayaran Kamu Tidak Valid',
        reject_desc: 'Silakan unggah bukti pembayaran baru',
        reject_cta: 'Unggah Bukti Pembayaran',
        pending: 'Pembayaran Kamu Sedang Diproses',
        pending_desc:
            'Silakan tunggu sebentar tim kami akan memeriksa pembayaran kamu',
        pending_cta: 'Beli Produk Lain',
        paid: 'Selamat. Pembayaran Kamu Diterima',
        paid_desc:
            'Terima kasih telah memesan di XiaokenShop. Kami akan memproses pesanan kamu secepat mungkin.',
        paid_cta: 'Lacak Pesanan'
    },
    order: {
        title: 'Riwayat Pesanan',
        search: 'Cari Pesanan',
        empty: 'Daftar Pesanan Kamu Kosong',
        empty_desc: 'Silakan Tambahkan Pesanan Baru!',
        cta: 'Tambah Produk',
        status: {
            all: 'Semua',
            process: 'Diproses',
            success: 'Selesai',
            cancel: 'Dibatalkan',
            failed: 'Gagal',
            reset: 'Reset Filter'
        },
        card: {
            price: 'Harga',
            shipping: 'Dikirim ke',
            detail: 'Detail Transaksi',
            total: 'Total Pembayaran',
            product: 'Total Produk',
            cancel: 'Batalkan Pesanan',
            help: 'Bantuan Pesanan',
            pay: 'Bayar Sekarang',
            again: 'Pesan Lagi'
        },
        detail: {
            title: 'Detail Transaksi',
            viewmore: 'Lihat Lebih',
            number: 'Nomor Pesanan',
            date: 'Tanggal Pesanan',
            order: 'Detail Produk',
            shipping: 'Detail Pengiriman',
            expedition: 'Ekspedisi',
            address: 'Alamat Pengiriman',
            payment: 'Detail Pembayaran',
            method: 'Metode Pembayaran',
            total: 'Total Belanja',
            shipping_cost: 'Biaya Pengiriman',
            gov: 'Pajak Pemerintah',
            payment_fee: 'Biaya Pembayaran',
            grand: 'Total Pembayaran',
            discount: 'Diskon'
        }
    },
    wishlist: {
        title: 'Favoritku',
        empty: 'Favorit Kamu Kosong',
        empty_desc: 'Jelajahi produk kami dan temukan produk favorit kamu!'
    },
    profile: {
        title: 'Ubah Profil',
        verify: 'Verifikasi akun',
        email_not: 'Email Belum Terverifikasi',
        email_yes: 'Akun Terverifikasi',
        first: 'Nama Depan',
        last: 'Nama Belakang',
        dob: 'Tanggal Lahir',
        phone: 'Nomor Telepon',
        password: 'Kata Sandi',
        confirm: 'Konfirmasi Kata Sandi',
        cta: 'Update Profil'
    },
    reset: {
        title: 'Reset Kata Sandi',
        desc: 'Silakan isi kolom di bawah ini untuk mereset kata sandi kamu',
        new: 'Kata Sandi Baru',
        confirm: 'Konfirmasi Kata Sandi Baru',
        cta: 'Ubah Kata Sandi'
    },
    forgot: {
        title: 'Lupa Kata Sandi?',
        desc: 'Masukkan alamat email Anda dan kami akan mengirimkan Anda tautan untuk mereset kata sandi Anda.'
    },
    footer: {
        address: 'Alamat',
        shopping: {
            head: 'Belanja',
            home: 'Laman Utama',
            request: 'Pesanan Custom',
            all_product: 'Semua Produk',
            discount: 'Produk Diskon'
        },
        about: {
            head: 'Tentang Kami',
            about: 'Tentang',
            news: 'Berita & Event',
            tnc: 'Syarat & Ketentuan',
            privacy: 'Kebijakan Privasi'
        },
        support: {
            head: 'Bantuan',
            shop_guide: 'Panduan Belanja',
            faq: 'FAQ',
            help: 'Hubungi Kami'
        },
        store: 'Toko Kami',
        payment: 'Pembayaran',
        follow: 'Ikuti Kami'
    },
}
